module.exports = __webpack_public_path__ + "static/media/ethNews.5a613f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/ethNews.png
// module id = 1817
// module chunks = 147